/**
 * 메인 이미지 슬라이더 컴포넌트
 */

import React from 'react';
import styled from '@emotion/styled';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { theme } from '../../../../shared/styles/theme';
import { mediaQueries } from '../../../../shared/constants/breakpoints';

// Swiper 스타일 import
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

interface Slide {
  id: number;
  imageUrl: string;
  title: string;
  description: string;
}

interface ImageSliderProps {
  slides: Slide[];
}

const SliderContainer = styled.div`
  width: 100%;
  aspect-ratio: 5 / 2;
  position: relative;

  .swiper {
    width: 100%;
    height: 100%;
  }

  .swiper-pagination-bullet {
    background: white;
    opacity: 0.6;
    width: 12px;
    height: 12px;
  }

  .swiper-pagination-bullet-active {
    opacity: 1;
    background: white;
  }

  .swiper-button-prev,
  .swiper-button-next {
    color: white;

    &::after {
      font-size: 30px;
      font-weight: bold;
    }

    ${mediaQueries.maxMobile} {
      display: none;
    }
  }
`;

const SlideImage = styled.div<{ imageUrl: string }>`
  width: 100%;
  height: 100%;
  background-image: url(${({ imageUrl }) => imageUrl});
  background-size: cover;
  background-position: center;
  background-color: ${theme.colors.primary};
  position: relative;
`;

export const ImageSlider: React.FC<ImageSliderProps> = ({ slides }) => {
  return (
    <SliderContainer>
      <Swiper
        modules={[Autoplay, Pagination, Navigation]}
        spaceBetween={0}
        slidesPerView={1}
        pagination={{ clickable: true }}
        navigation
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        loop={true}
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            <SlideImage imageUrl={slide.imageUrl} />
          </SwiperSlide>
        ))}
      </Swiper>
    </SliderContainer>
  );
};
